var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _vm.component,
    _vm._b({ tag: "component" }, "component", _vm.componentsProps, false)
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }